<template>
    <v-data-table
        dense
        :headers="headers"
        :options.sync="options"
        :items="gridData"
        :server-items-length="gridDataTotalCount"
        class="elevation-1"
        :footer-props="footerProps"
        @click:row="HandleRowClick"
    >
        <template v-slot:no-data>
            <v-btn color="primary" @click="ReloadGrid">{{ $t('Refresh') }}</v-btn>
        </template>
    </v-data-table>
</template>

<script>
import medicamentService from '@/service/medicament-service';

export default {
    props: {
        source: Number,
        includeDeleted: Boolean,
        withBrunvaAccess: Boolean,
        departmentCode: Number,
        unitType: Number,
        onlyEhrMedicaments: Boolean,
        hasMohProductId: Boolean,
        productGeneric: String
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            gridData: [],
            gridDataTotalCount: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            headers: [
                { text: this.$t('Code'), value: 'Code', sortable: false },
                { text: this.$t('Name'), value: 'Name', sortable: false },
                { text: this.$t('OtherDetails'), value: 'OtherDetailsGeo', sortable: false },
            ]
        };
    },
    mounted() {
        this.GetData();
    },
    methods: {
        async GetData() {
            const { page, itemsPerPage } = this.options;
            let filter = {};
            if (this.source && this.source > 0) {
                filter.Source = this.source;
            }
            if (this.includeDeleted) {
                filter.IncludeDeleted = true;
            }
            if (this.withBrunvaAccess || this.withBrunvaAccess === false) {
                filter.withBrunvaAccess = this.withBrunvaAccess;
            }
            if (this.departmentCode || this.departmentCode === false) {
                filter.departmentCode = this.departmentCode;
            }
            filter.UnitType = this.unitType || null;
            if (this.onlyEhrMedicaments) {
                filter.OnlyEhrMedicaments = true;
            }
            if (this.hasMohProductId) {
                filter.MohProductId_Not = 0;
            }
            if (this.productGeneric) {
                filter.ProductGeneric = this.productGeneric;
            }

            let response = await medicamentService.getData(page, itemsPerPage, filter);
            this.gridData = response.data;
            this.gridDataTotalCount = response.total;
        },
        async ReloadGrid() {
            await this.GetData();
        },
        HandleRowClick(item) {
            this.$emit('select', item);
        }
    }
}
</script>